module.exports = __webpack_public_path__ + "img/QR Scan.da003b95.svg";